import { RootState } from "../../redux/configureStore";
import { isAfter, parseISO } from "date-fns";

const useStaging = process.env.REACT_APP_MOLO_DEV === "staging";

export const authSelector = (state: RootState) => state.auth;

export const isAuthedSelector = (state: RootState) => {
  if (useStaging) {
    return true;
  }
  return (
    state.auth.expires_at !== null &&
    isAfter(parseISO(state.auth.expires_at), new Date())
  );
};
